var _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgWarning = function SvgWarning(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "outline/16*16/informative/warning"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Vector"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.66738 11.334C8.66738 11.7022 8.3689 12.0007 8.00071 12.0007C7.63252 12.0007 7.33404 11.7022 7.33404 11.334C7.33404 10.9659 7.63252 10.6674 8.00071 10.6674C8.3689 10.6674 8.66738 10.9659 8.66738 11.334Z",
    fill: "#E87309"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.1247 2.48066C6.9453 1.0403 9.05611 1.0403 9.87671 2.48066L14.9915 11.4583C15.8061 12.8882 14.7311 14.6004 13.1155 14.6004H2.88597C1.27031 14.6004 0.195333 12.8882 1.00996 11.4583L6.1247 2.48066ZM8.83406 3.07468C8.47377 2.44229 7.52765 2.44229 7.16736 3.07468L2.05262 12.0523C1.71956 12.637 2.13839 13.4004 2.88597 13.4004H13.1155C13.863 13.4004 14.2819 12.637 13.9488 12.0523L8.83406 3.07468ZM8.00067 5.40037C8.33204 5.40037 8.60067 5.669 8.60067 6.00037V9.3337C8.60067 9.66508 8.33204 9.9337 8.00067 9.9337C7.6693 9.9337 7.40067 9.66508 7.40067 9.3337V6.00037C7.40067 5.669 7.6693 5.40037 8.00067 5.40037Z",
    fill: "#E87309"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgWarning);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "warning.ebe0ec3462be5d7eba7a058b23ddb01f.svg";